import { AddressFormFieldNames } from 'shared/enums/addressFormFieldNames';
import { createFormConfig, ValidationRules } from 'helpers/createFormConfig';
import { PimFormValues } from './PimFormValues';
import { pimValidationRules } from './pimValidationRules';

const pimFormConfig = createFormConfig<PimFormValues>(
  pimValidationRules as ValidationRules<keyof PimFormValues>,
  {
    [AddressFormFieldNames.Country]: 'FR',
  }
);

export { pimFormConfig };
